export default __webpack_public_path__ + "static/media/layout.80d89806.png";